// src/components/FeedbackList.jsx

export default function FeedbackList({ feedback }) {
  if (!feedback) return null;

  const deductions = Array.isArray(feedback.deductions)
    ? feedback.deductions
    : [];

  const hasErrors = deductions.length > 0;

  return (
    <div
      style={{
        marginTop: 14,
        paddingTop: 10,
        borderTop: "1px solid #ddd",
        fontSize: 14
      }}
    >
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          margin: 0,
          display: "flex",
          flexDirection: "column",
          gap: 6
        }}
      >
        {/* ✅ ALL CORRECT */}
        {!hasErrors && (
          <li
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 8,
              color: "#2e7d32"
            }}
          >
            <span
              style={{
                width: 18,
                textAlign: "center",
                fontWeight: "bold",
                flexShrink: 0
              }}
            >
              ✓
            </span>
            <span>
              <strong>Correct</strong>
            </span>
          </li>
        )}

        {/* ❌ DEDUCTIONS */}
        {deductions.map((d, i) => (
          <li
            key={d.key ?? i}
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 8,
              color: "#c62828"
            }}
          >
            <span
              style={{
                width: 18,
                textAlign: "center",
                fontWeight: "bold",
                flexShrink: 0
              }}
            >
              ✗
            </span>

            <span>
              <strong>{d.label || "Incorrect"}</strong>
              {typeof d.points === "number" && (
                <span style={{ marginLeft: 6, color: "#555" }}>
                  (−{formatPoints(d.points)})
                </span>
              )}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

/* ───────────────────── HELPERS ───────────────────── */

function formatPoints(p) {
  return Number.isInteger(p) ? p : p.toFixed(2);
}
